module.exports = __webpack_public_path__ + "img/volume.ce35a355.svg";